import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState: PartnerState = {
  partner: {
    publicId: "",
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    dateOfBirth: "",
    age: 0,
    dateOfBirthStr: "",
    address: {
      street1: "",
      street2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
    },
    ownerStaff: {
      publicId: "",
      username: "",
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      signature: "",
      createdBy: "",
      type: "",
      whenCreated: "",
      updatedBy: "",
      whenLastUpdated: "",
      siteExternalId: "",
    },
    createdBy: "",
    whenCreated: "",
    partnerPublicId: "",
    profilePictureUrl: "",
    patientDetails: {
      gpDetails: {
        name: "",
        email: "",
        phoneNo: "",
        contact: "",
        address: {
          street1: "",
          street2: "",
          city: "",
          state: "",
          postalCode: "",
          country: "",
        },
      },
      nextOfKin: {
        name: "",
        contact: "",
        relation: "",
      },
      allergies: "",
      referralSource: "",
      fundingSource: "",
      weight: 0,
      weightUnit: "",
      height: 0,
      heightUnit: "",
      occupation: "",
      smoking: false,
      tryingSinceYears: 0,
      tryingSinceMonths: 0,
      cpLiveChildren: 0,
      ppLiveChildren: 0,
      obstetricsHistory: "",
      medicalHistory: "",
      surgeryHistory: "",
      medications: "",
      significantGeneticHistory: "",
      smearsCervix: "",
      treatmentOnCervix: "",
      periods: "",
      periodsComment: "",
      rubellaImmune: false,
      primaryDiagnosis: [],
      secondaryDiagnosis: [],
      subfertility: "",
      additionalComments: "",
    },
  },
};

export const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    addPartnerInformation: (
      state: PartnerState,
      action: PayloadAction<PatientInformation>
    ) => {
      state.partner = action.payload;
    },
    removePartnerInformation: (state: PartnerState) => {
      state.partner = initialState.partner;
    },
    getPartnerInformation: (state: PartnerState) => {
      return state;
    },
  },
});

export default partnerSlice.reducer;
export const {
  addPartnerInformation,
  removePartnerInformation,
  getPartnerInformation,
} = partnerSlice.actions;
